import { z } from 'zod';
import { listQuerySchema } from '../common/pagination';

/** Lieferadresse (eigenständige Zusatzadresse, SoftENGINE satzart=L). */
export const deliveryAddressResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  number: z.string().nullable(),
  name: z.string(),
  street: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  countryName: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  matchcode: z.string().nullable(),
  customerId: z.string().uuid().nullable(),
  customerNumber: z.string().nullable(),
  customerName: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type DeliveryAddressResponse = z.infer<typeof deliveryAddressResponseSchema>;

/** Listen-Query (Suche/Pagination/Sortierung) für Lieferadressen. */
export const deliveryAddressListQuerySchema = listQuerySchema.extend({
  /** Nur Lieferadressen, die diesem Kunden zugeordnet sind. */
  customerId: z.string().uuid().optional(),
});
export type DeliveryAddressListQuery = z.infer<typeof deliveryAddressListQuerySchema>;

const shortText = (max: number) => z.string().trim().max(max).optional();

/** Anlegen einer Lieferadresse (z. B. aus dem Kunden-Detail-Tab). */
export const createDeliveryAddressSchema = z.object({
  name: z.string().trim().min(1).max(200),
  street: shortText(200),
  postalCode: shortText(20),
  city: shortText(120),
  /** ISO-Land (z. B. „DE"). */
  country: shortText(10),
  /** Land im Klartext (z. B. „Deutschland"). */
  countryName: shortText(120),
  email: z.string().trim().email().max(200).optional().or(z.literal('')),
  phone: shortText(50),
  matchcode: shortText(120),
  notes: z.string().trim().max(2000).optional(),
  /** Verknüpfung zum Stammkunden — die Kundennummer wird serverseitig aufgelöst. */
  customerId: z.string().uuid().nullable().optional(),
});
export type CreateDeliveryAddressInput = z.infer<typeof createDeliveryAddressSchema>;

/** Ändern/Verknüpfen einer Lieferadresse (alle Felder optional). */
export const updateDeliveryAddressSchema = createDeliveryAddressSchema.partial();
export type UpdateDeliveryAddressInput = z.infer<typeof updateDeliveryAddressSchema>;
